import { useContext, useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
// import IntroAnimation from "./animations/IntroAnimation";
import Navbar from "./components/Navbar/Navbar";
import StrategyCallModal from './components/Modals/StrategyCallModal.jsx';
import { ModalContext } from './context/ModalContext.jsx';
import { initGA, trackPageView } from "./utils/google-analytics";

// chatbots
import ChatbotModal from "./components/Modals/chatbot/ChatbotModal";
import ChatbotLauncher from "./components/Modals/chatbot/ChatbotLauncher";

// Loader (NEW)
import RouteLoader from "./components/Loader/RouteLoader";

// Pages
import Home from "./pages/Home/Home";
import AboutUs from "./pages/WhoWeAre/AboutUs";
import Career from "./pages/WhoWeAre/Career";
import Contact from "./pages/WhoWeAre/Contact";

import Services from "./pages/WhatWeDo/Services";
import Products from "./pages/WhatWeDo/Products";
import Technologies from "./pages/WhatWeDo/Technologies";

import GenAiLab from "./pages/GenAILab/GenAiLab";
import Blogs from "./pages/Blogs/Blogs";

import DefenceOverview from "./pages/Defence/DefenceOverview/DefenceOverview.jsx";
import DefenceExpertise from "./pages/Defence/DefenceExpertise/DefenceExpertise.jsx";
import DefenceProducts from "./pages/Defence/DefenceProducts/DefenceProducts.jsx";
import DefenceSupport from "./pages/Defence/DefenceSupport/DefenceSupport.jsx";

import Footer from "./components/Footer/Footer.jsx";
import PrivacyPolicy from "./pages/Policies/PrivacyPolicy.jsx";
import TermsAndCondition from "./pages/Policies/TermsAndCondition.jsx";

// import not found page if there is any updation
// import NotFound from "./pages/NotFound.jsx"; 

function App() {

  const { isStrategyOpen } = useContext(ModalContext);
  const [showIntro, setShowIntro] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const hasSeenIntro = sessionStorage.getItem("introShown");

    if (!hasSeenIntro) {
      setShowIntro(true);
      sessionStorage.setItem("introShown", "true");
    }
  }, []);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

// lastchange
// Init GA once
useEffect(() => {
  initGA();
}, []);

// Track page views on route change
useEffect(() => {
  trackPageView(location.pathname);
  window.scrollTo(0, 0);
}, [location]);
  return (
    <>
      {/* ✅ ROUTE BASED LOADER (NO HOME) */}
      <RouteLoader exclude={["/"]} />

      {/* Intro animation (runs once) */}
      {/* {showIntro && <IntroAnimation onFinish={() => setShowIntro(false)} />} */}

      {/* Global navbar */}
      <Navbar />
      {isStrategyOpen && <StrategyCallModal />}

      {/* Chatbot */}
      {chatOpen && <ChatbotModal onClose={() => setChatOpen(false)} />}
      <ChatbotLauncher onOpen={() => setChatOpen(true)} />

      {/* Page content */}
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/career" element={<Career />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/services" element={<Services />} />
        <Route path="/products" element={<Products />} />
        <Route path="/technologies" element={<Technologies />} />

        <Route path="/genai-lab" element={<GenAiLab />} />

        <Route path="/blogs" element={<Blogs />} />
        {/* DEFENCE PAGES (NO PARENT ROUTE) */}
        <Route path="/defence-overview" element={<DefenceOverview />} />
        <Route path="/defence-expertise" element={<DefenceExpertise />} />
        <Route path="/defence-products" element={<DefenceProducts />} />
       <Route path="/defence-support" element={<DefenceSupport />} />


        <Route path="*" element={<Home />} />
        <Route path="/Privacy" element={<PrivacyPolicy />} />
        <Route path="/Terms" element={<TermsAndCondition />} />

        {/* comment out not found page at website updation */}
        {/* <Route path="/notfound" element={<NotFound />} /> */}
      </Routes>

      <Footer />
    </>
  );
}

export default App;
